import React, { Component } from 'react';
import { Modal } from 'react-bootstrap';
import Select from 'react-select';
import axios from 'axios';
import { kinetik_api_url } from '../../utilities/const';


class EditUserModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            userTypes: [
                { label: 'Manager', value: 2 },
                { label: 'Standard', value: 3 }
            ],
            selectedUserType: {}
        };

    }

    updateVal = (v) => {
        this.setState({
            selectedUserType: v
        })
    }

    handleUserType = (selected) => {
        /* selected is a object of label:, value: key. */
        // console.log(selected);
        this.setState({
            selectedUserType: selected
        })
    }



    userChangesHandler = () => {
        let token = localStorage.getItem('authToken');
        let requesterUserType = localStorage.getItem('userType');
        let userType = this.state.selectedUserType.value;
        let URL = kinetik_api_url + '/update_user';
        let first_name = document.getElementById('first_name').value;
        let last_name = document.getElementById('last_name').value;
        let email = document.getElementById('email_val').value;

        axios.put(URL, {
            user_id: this.props.userData.user_id,
            token,
            userType,
            first_name,
            last_name,
            email,
            requesterUserType

        })
        .then( (result) => {
            window.alert(result.data.message);
            this.props.hideOrShowEditingModal();
        })
        .catch( (err) => {
            console.log(err);
        })

    }
    render() {
        let {
            first_name,
            last_name,
            email
        } = this.props.userData
        return (
            <div>
                <Modal show={this.props.show} onHide={this.props.hideOrShowEditingModal} className="userEdit_m">
                    <Modal.Header className="boarding_header_wrapper user_editing_h">
                        <Modal.Title>
                            <div className="boarding_modal_header user_editing_t">
                                <h3>Edit User</h3>
                                <span>Update User Information From Here</span>
                            </div>
                        </Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-md-12">
                                <div className="brd_tab_cntnt settings_page_profile">
                                    <div className="brding_frm_ele">
                                        <span>First Name</span>
                                        <input defaultValue={first_name} id="first_name" type="text" placeholder="First Name" />
                                    </div> <br />
                                    <div className="brding_frm_ele">
                                        <span>Last Name</span>
                                        <input defaultValue={last_name} id="last_name" type="text" placeholder="Last Name" />
                                    </div> <br />
                                    <div className="brding_frm_ele">
                                        <span>User Email</span>
                                        <input defaultValue={email} id="email_val" type="text" placeholder="User Email" />
                                    </div> <br />
                                    <div className="brding_frm_ele">
                                        <span>User Type</span>
                                        <Select
                                            clearable={false}
                                            disabled={false}
                                            className="edit_user_type"
                                            options={this.state.userTypes}
                                            value={this.state.updateVal}
                                            onChange={this.handleUserType}

                                        />
                                    </div> <br />
                                </div>
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="brding_footer_wrapper user_editing_f_w">
                        <button onClick={this.props.hideOrShowEditingModal} className="cancel_btn_brding">Cancel</button>
                        <button onClick={this.userChangesHandler} className="save_btn_brding">Update</button>
                    </Modal.Footer>
                </Modal>
            </div>
        );
    }
}
export default EditUserModal;


// WEBPACK FOOTER //
// ./src/app/profile_settings/users/editUserModal.js